export function EventNavLabel({
  isNew = false,
}: {
  isNew?: boolean;
}): React.ReactElement {
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap">
      イベント
      {isNew && (
        <strong className="rounded border border-primary px-1 py-0.5 text-[0.625rem] font-bold leading-none text-primary">
          NEW
        </strong>
      )}
    </span>
  );
}
